import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Pricing cards with optional highlight variant.
 *
 * Props:
 *   packages - array of {
 *     label, examples, price, priceSub, highlight, badgeText,
 *     features: string[], linkTo: { pathname, state }, btnLabel
 *   }
 */
const PricingGrid = ({ packages = [] }) => {
  if (packages.length === 0) return null;

  return (
    <div className="rr-pricing-grid">
      {packages.map((pkg) => (
        <div
          key={pkg.label}
          className={`rr-pricing-card${pkg.highlight ? ' rr-pricing-card--highlight' : ''}`}
        >
          {pkg.highlight && pkg.badgeText && (
            <div className="rr-pricing-card__badge">{pkg.badgeText}</div>
          )}
          <div className="rr-pricing-card__label">{pkg.label}</div>
          {pkg.examples && (
            <div className="rr-pricing-card__examples">{pkg.examples}</div>
          )}
          <div className="rr-pricing-card__price">{pkg.price}</div>
          {pkg.priceSub && (
            <div className="rr-pricing-card__price-sub">{pkg.priceSub}</div>
          )}
          {pkg.features && pkg.features.length > 0 && (
            <ul className="rr-pricing-card__features">
              {pkg.features.map((f) => (
                <li key={f} className="rr-pricing-card__feature-item">
                  <span className="rr-pricing-card__feature-check">✓</span>
                  {f}
                </li>
              ))}
            </ul>
          )}
          {pkg.linkTo ? (
            <Link to={pkg.linkTo} className="rr-pricing-card__btn">
              {pkg.btnLabel || 'Book Now'}
            </Link>
          ) : pkg.href ? (
            <a href={pkg.href} className="rr-pricing-card__btn">
              {pkg.btnLabel || 'Book Now'}
            </a>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default PricingGrid;
